import React from 'react';
import PropTypes from 'prop-types';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

import settings from '../../settings';
import '../../sass/style.scss';
import '../../sass/layouts/_index.scss';

class IndexTemplateWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuVisible: false,
    };
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.completeOrder = this.completeOrder.bind(this);
    // this.checkDiscount = this.checkDiscount.bind(this);
  }

  componentDidMount() {
    Snipcart.subscribe('order.completed', data => completeOrder(data));
  }

  completeOrder(data) {
    const updateItems = [];
    data.items.map((item, index) => {
      const itemID = item.id.replace('product_', '');
      const quantity = item.maxQuantity - item.quantity;

      updateItems.push({
        id: itemID,
        count: quantity,
      });
    });

    const url = `${settings.directus_api.protocol}://${
      settings.directus_api.url
    }/api/1.1/tables/stock/rows/bulk`;

    fetch(url, {
      method: 'put',
      body: JSON.stringify({ rows: updateItems }),
      headers: new Headers({
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${settings.directus_api.apiKey}`,
        'Access-Control-Request-Method': 'PUT',
      }),
    })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.log(error);
        },
      );
  }

  handleToggleMenu() {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible,
    });
  }

  render() {
    return (
      <div className={`index ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
        <SEO pageName={this.props.location.pathname} />
        <Sidebar
          instagramUser={this.props.data.user.edges[0].node}
          instagramPosts={this.props.data.posts.edges}
        />
        <Header
          title={settings.site.title}
          subtitle={settings.site.subtitle}
          menuClick={this.handleToggleMenu}
          isMenuVisible={this.state.isMenuVisible}
        />
        <main>
          <Menu menuClick={this.handleToggleMenu} />
          {this.props.children()}
          <Footer />
        </main>
      </div>
    );
  }
}

IndexTemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default IndexTemplateWrapper;

export const indexLayoutQuery = graphql`
  query indexLayoutQuery {
    user: allPostsJson(limit: 1) {
      edges {
        node {
          userName
          userFullName
          userBio
          userFollowers
          userPostCount
          id
          code
          likes
          comment
          text
          type
          image {
            childImageSharp {
              sizes(maxWidth: 230, quality: 75) {
                ...GatsbyImageSharpSizes
                originalName
              }
            }
          }
        }
      }
    }
    posts: allPostsJson(limit: 13) {
      edges {
        node {
          id
          code
          likes
          comment
          type
          text
          image {
            childImageSharp {
              sizes(maxWidth: 80, quality: 75) {
                ...GatsbyImageSharpSizes
                originalName
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js